import { INIT_EDIT_QUOTE } from 'store/quotes/types';

import { types } from './actions';

const initialState = {
  isConfirmationModalOpen: false,
  isMaterialModalOpen: false,
  isMaterialModalSaving: false,
  localSupplierMaterial: null,
  component: null,
};

export default function confirmModal(state = initialState, action) {
  const { type } = action;

  switch (type) {
    case INIT_EDIT_QUOTE:
      return { ...initialState };
    case types.OPEN_CONFIRM_QPV_PROCESS_MATERIAL_MODAL:
      return {
        ...state,
        isConfirmationModalOpen: true,
        component: action.payload.component,
      };
    case types.CLOSE_CONFIRM_QPV_PROCESS_MATERIAL_MODAL:
      return {
        ...state,
        isConfirmationModalOpen: false,
        component: null,
      };
    case types.CONFIRM_UPDATE_QPV_PROCESS_MATERIAL_REQUEST:
      return {
        ...state,
        isConfirmationModalOpen: false,
        component: null,
      };
    case types.QPV_MATERIAL_MODAL_OPEN:
      return {
        ...state,
        isMaterialModalOpen: true,
      };
    case types.QPV_MATERIAL_MODAL_CLOSE:
      return {
        ...state,
        isMaterialModalOpen: false,
      };
    case types.QPV_MATERIAL_MODAL_SAVE_REQUEST:
      return {
        ...state,
        isMaterialModalSaving: true,
      };
    case types.QPV_MATERIAL_MODAL_SAVE_SUCCESS:
      return {
        ...state,
        isMaterialModalOpen: false,
        isMaterialModalSaving: false,
      };
    case types.QPV_MATERIAL_MODAL_SAVE_ERROR:
      return {
        ...state,
        isMaterialModalSaving: false,
      };
    case types.UPDATE_LOCAL_SUPPLIER_MATERIAL:
      return {
        ...state,
        localSupplierMaterial: action.payload.supplierMaterial,
      };
    default:
      return state;
  }
}

const getScope = (state) => state.modules.quotePartViewer.app.modalsReducer;

export const getIsConfirmationModalOpen = (state) =>
  getScope(state).isConfirmationModalOpen;

export const getIsMaterialModalOpen = (state) =>
  getScope(state).isMaterialModalOpen;

export const getIsMaterialModalSaving = (state) =>
  getScope(state).isMaterialModalSaving;

export const getLocalSupplierMaterial = (state) =>
  getScope(state).localSupplierMaterial;

export const getComponent = (state) => getScope(state).component;
